import { jsx } from 'react/jsx-runtime';
import ToastConsumer from './ToastConsumer.js';

function withToastConsumer(Component) {
    return function withToastConsumer(props) {
        return (jsx(ToastConsumer, { children: ({ showToast }) => jsx(Component, Object.assign({}, props, { showToast: showToast })) }));
    };
}

export { withToastConsumer };
